import React from "react";
import styled from "styled-components";
import { PropTypes } from "prop-types";

const EmployeeCardContainerGrid = styled.div.attrs(({ $columns }) => ({
  $columns: $columns,
}))`
  display: grid;
  grid-template-columns: ${({ $columns }) => `repeat(${$columns}, 1fr)`};
  width: 100%;
  justify-items: center;
  gap: 1rem;
  @media (max-width: ${({ theme }) => theme.breakpoints.wideTablet}) {
    grid-template-columns: 1fr 1fr;
  }
  @media (max-width: ${({ theme }) => theme.breakpoints.phone}) {
    justify-content: start;
    display: flex;
    flex-flow: row wrap;
  }
`;

const EmployeeCardContainerList = styled.div`
  display: flex;
  width: 100%;
  flex-flow: column wrap;
  gap: 2rem;
  @media (max-width: ${({ theme }) => theme.breakpoints.phone}) {
    gap: 1rem;
  }
`;

const EmployeeCardContainer = ({
  columns,
  postLayout,
  children,
  className,
}) => {
  return (
    <>
      {postLayout === "grid" ? (
        <EmployeeCardContainerGrid $columns={columns} className={className}>
          {children}
        </EmployeeCardContainerGrid>
      ) : (
        <EmployeeCardContainerList className={className}>
          {children}
        </EmployeeCardContainerList>
      )}
    </>
  );
};

EmployeeCardContainer.propTypes = {
  children: PropTypes.node,
  columns: PropTypes.number,
  postLayout: PropTypes.string,
  className: PropTypes.string,
};

export default EmployeeCardContainer;
